import {Fragment, useEffect, useState} from "react";
import {format} from "date-fns";
import {BreadCrumb, CenteredModal, DropdownAction, TablePaging} from "~/components";
import MailjetAPI from '~/api/mailjetApi';
import {faEdit, faEye, faTrash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const breadCrumbItem = [
    { text: "Home", to: "/ai-chatbot/administrator", isActive: false },
    { text: "Mailjet Management", to: "", isActive: true },
]

function MailjetManagement() {
    const [dashboardStats, setDashboardStats] = useState({});
    const [reloadTable, setReloadTable] = useState(false);
    const tablePagingConfig = {
        columns: [
            {
                name: 'ID',
                width: '100px',
                className: 'fw-bold',
                key: 'ID'
            },
            {
                name: 'EMAIL',
                width: '200px',
                key: 'Email'
            },
            {
                name: 'NAME',
                width: '100px',
                key: 'Name'
            },
            {
                name: 'CREATED AT',
                width: '120px',
                key: 'CreatedAt',
                template: (row) => {
                    return (
                        <span>{format(new Date(row.CreatedAt), "dd-MM-yyyy")}</span>
                    )
                }
            },
            {
                name: 'DELIVERED COUNT',
                width: '130px',
                key: 'DeliveredCount'
            },
            {
                name: 'EFC UPDATED AT',
                width: '150px',
                key: 'ExclusionFromCampaignsUpdatedAt'
            },
            {
                name: 'IS EFC', // ExcludedFromCampaigns
                width: '100px',
                key: 'IsExcludedFromCampaigns',
                template: (row) => {
                    return (
                        row.IsExcludedFromCampaigns ?  <span> true</span> : <span> false</span>
                    )
                }
            },
            {
                name: 'IS OPT IN PENDING',
                width: '150px',
                key: 'IsOptInPending',
                template: (row) => {
                    return (
                        row.IsOptInPending ?  <span> true</span> : <span> false</span>
                    )
                }
            },
            {
                name: 'IS SPAM COMPLAINING',
                width: '170px',
                key: 'IsSpamComplaining',
                template: (row) => {
                    return (
                        row.IsSpamComplaining ?  <span> true</span> : <span> false</span>
                    )
                }
            },
            {
                name: 'LAST ACTIVITY AT',
                width: '150px',
                key: 'LastActivityAt',
                template: (row) => {
                    return (
                        <span>{format(new Date(row.LastActivityAt), "dd-MM-yyyy")}</span>
                    )
                }
            },
            {
                name: 'LASTUPDATE AT',
                width: '150px',
                key: 'LastUpdateAt',
                template: (row) => {
                    return (
                        <span>{format(new Date(row.LastUpdateAt), "dd-MM-yyyy")}</span>
                    )
                }
            },
            {
                name: 'UNSUBSCRIBED AT',
                width: '140px',
                key: 'UnsubscribedAt'
            },
            {
                name: 'UNSUBSCRIBED BY',
                width: '140px',
                key: 'UnsubscribedBy'
            },
            {
                name: 'ACTION',
                width: '70px',
                className: 'text-center',
                headerClassName: 'text-center',
                key: 'Action',
                template: (row) => {
                    return (
                        <span><FontAwesomeIcon onClick={()=> handleShowDeleteModal(row.ID)} icon={faTrash} className="text-danger cursor-pointer"/></span>
                    )
                }
            }
        ],
        url: "/mailjet/contact/all",
        tableKey: "TableMailjetManagement"
    }

    const handleShowDeleteModal = (id) => {

    }

    useEffect(() => {
        MailjetAPI.getDashboardStats()
            .then(res => {
                setDashboardStats(res.data);
            })
            .catch(err => {});
    }, [])

    return (
        <Fragment>
            <BreadCrumb breadCrumbItem={breadCrumbItem}/>
            <h2 className="text-bold text-body-emphasis mb-4">Mailjet Management</h2>
            <div className="mb-2 nav nav-links mx-n2 nav">
                {Object.entries(dashboardStats).map(([key, value]) => (
                    <div className="nav-item" key={key}>
                        <div className="px-2 py-1 active nav-link text-primary" tabIndex="0">{key}
                            <span className="text-body-tertiary fw-semibold">({value})</span>
                        </div>
                    </div>
                ))}
            </div>
            <TablePaging tablePagingConfig={tablePagingConfig} ableSearch={false} reloadTable={reloadTable}/>
        </Fragment>
    )
}

export default MailjetManagement;